import { render, staticRenderFns } from "./addtocatalog-selected.vue?vue&type=template&id=ee2d40c4&scoped=true&"
import script from "./addtocatalog-selected.vue?vue&type=script&lang=js&"
export * from "./addtocatalog-selected.vue?vue&type=script&lang=js&"
import style0 from "./addtocatalog-selected.vue?vue&type=style&index=0&id=ee2d40c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2d40c4",
  null
  
)

export default component.exports